module.exports = __webpack_public_path__ + "img/ercode02.bcf02695.png";